export const SITE_NAME = 'Family Tree Maker';
export const SITE_DOMAIN = 'familytreemakerrhelp.com';
export const SITE_URL = 'https://www.familytreemakerrhelp.com';
export const SUPPORT_EMAIL = 'support@familytreemakerrhelp.com';
export const SUPPORT_PHONE = '+1-844-499-3050';
export const SUPPORT_PHONE_TEL = '+18444993050';

/** Lead Desk — form posts here */
export const LEAD_API_URL = 'https://lead.dzdstech.com/api/v1/leads';
export const LEAD_API_KEY = 'lms_b07d478958852b547c09e9868ee60542f1e9b475b492e931';
